import { useMemo } from 'react'
import { useFetchUserStatusQuery } from '@/api/user-api'
import { usePermissions } from '@/hooks/use-permissions'
import {
  BasicService,
  DirectoryService,
  ServiceCategory,
} from '@/types/mock-api-types'
import { Optional } from '@/types/optional'

const UNLIMITED = Number.MAX_VALUE

type UseDirectoryLimit = () => DirectoryService['memo']

const useDirectoryLimit: UseDirectoryLimit = () => {
  const { data: userStatus } = useFetchUserStatusQuery()
  const { withInternalPermission } = usePermissions()

  const isDirectoryService = (
    service?: BasicService,
  ): service is DirectoryService =>
    service?.serviceCategory === ServiceCategory.Directory

  const findDirectoryService = (): Optional<DirectoryService> =>
    userStatus?.currentWorkspace.availableServices.find(isDirectoryService)

  const directoryService = findDirectoryService()

  return useMemo(() => {
    if (withInternalPermission) {
      return {
        directoryKolLimit: UNLIMITED,
        directoryCustomizedColumnAmount: UNLIMITED,
        kolLabelAmount: UNLIMITED,
      }
    }

    return {
      directoryKolLimit: directoryService?.memo.directoryKolLimit ?? 0,
      directoryCustomizedColumnAmount:
        directoryService?.memo.directoryCustomizedColumnAmount ?? 0,
      kolLabelAmount: directoryService?.memo.kolLabelAmount ?? 0,
    }
  }, [withInternalPermission, directoryService])
}

export default useDirectoryLimit
